/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Example_BodyInputs */

const tr_katalog_desi_page_example_body = /** @type {(inputs: Katalog_Desi_Page_Example_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 × 20 × 50 cm ölçülerinde bir koli: (30 × 20 × 50) / 3000 = 10 desi. Paketin gerçek ağırlığı 7 kg olsa bile kargo 10 desi (10 kg) üzerinden ücretlendirilir.`)
};

const en_katalog_desi_page_example_body = /** @type {(inputs: Katalog_Desi_Page_Example_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A box of 30 × 20 × 50 cm: (30 × 20 × 50) / 3000 = 10 desi. Even if the actual weight is 7 kg, shipping is charged on 10 desi (10 kg).`)
};

const de_katalog_desi_page_example_body = /** @type {(inputs: Katalog_Desi_Page_Example_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Karton mit 30 × 20 × 50 cm: (30 × 20 × 50) / 3000 = 10 Desi. Selbst wenn das echte Gewicht 7 kg beträgt, wird der Versand mit 10 Desi (10 kg) berechnet.`)
};

const ru_katalog_desi_page_example_body = /** @type {(inputs: Katalog_Desi_Page_Example_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коробка 30 × 20 × 50 см: (30 × 20 × 50) / 3000 = 10 деси. Даже если реальный вес 7 кг, доставка считается по 10 деси (10 кг).`)
};

/**
* | output |
* | --- |
* | "A box of 30 × 20 × 50 cm: (30 × 20 × 50) / 3000 = 10 desi. Even if the actual weight is 7 kg, shipping is charged on 10 desi (10 kg)." |
*
* @param {Katalog_Desi_Page_Example_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_example_body = /** @type {((inputs?: Katalog_Desi_Page_Example_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Example_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_example_body(inputs)
	if (locale === "de") return de_katalog_desi_page_example_body(inputs)
	if (locale === "ru") return ru_katalog_desi_page_example_body(inputs)
	return tr_katalog_desi_page_example_body(inputs)
});